import Link from "next/link";
import { useAnalytics } from "~/components/Analytics";
import { ContentItemGrid } from "~/components/ContentItemGrid";
import {
  ContentItemWithImage,
  ContentItemWithImageProps,
} from "~/components/ContentItemWithImage";

export type ContentPromoPost = Pick<
  ContentItemWithImageProps,
  | "id"
  | "imageSrc"
  | "headline"
  | "imageAlt"
  | "footer"
  | "kicker"
  | "imagePosition"
  | "isChartPack"
> & {
  href: string;
  /** Human-readable slug used solely for analytics */
  slug: string;
};

export type ContentPromoProps = {
  /** The headline component to render */
  headline: React.ReactNode;
  posts: ContentPromoPost[];
};

export const ContentPromo: React.FC<ContentPromoProps> = ({
  headline,
  posts,
}: ContentPromoProps) => {
  const { analyticsEnhancedTrack } = useAnalytics();
  const onClick = (post: ContentPromoPost) => {
    analyticsEnhancedTrack("Content: Related Content", {
      selectedPost: post.slug,
    });
  };

  return (
    <div className="block w-full" data-testid="promos">
      <div className="mb-m">{headline}</div>
      <ContentItemGrid variant="3-item-row" itemBorder={false}>
        {posts.map((post, index) => (
          <Link
            className="outline-offset-2 outline-brand"
            key={index}
            href={post.href}
            onClick={() => onClick(post)}
          >
            <ContentItemWithImage {...post} imagePosition="top" />
          </Link>
        ))}
      </ContentItemGrid>
    </div>
  );
};
